<template>
  <div>
    <v-navigation-drawer
      fixed
      app
      permanent
      stateless
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-toolbar style="height: 57px;" flat color="primary white--text">
        <img
          alt="NVE logo"
          height="40px"
          style="margin-top: -10px;"
          :src="getImgUrl(logoImagePath)"
        />
        <v-list>
          <v-list-tile class="primary">
            <v-list-tile-title class="title white--text">
              {{ appTitle }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider />
      <v-divider />
      <v-list-group value="true" role="list">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Kategorier</v-list-tile-title>
          </v-list-tile>
        </template>

        <template v-for="item in profileCategories">
          <v-list-tile
            v-if="
              !item.hasOwnProperty('internal') ||
                item.internal === false ||
                isConnectedToIntranet
            "
            :key="item.title"
            @click="selectedProfileCategory = item.title"
          >
            <v-list-tile-avatar size="30">
              <v-icon
                :class="{
                  'active-category blue--text':
                    selectedProfileCategory == item.title,
                }"
                >{{ item.icon }}</v-icon
              >
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title
                :class="{
                  'active-category blue--text':
                    selectedProfileCategory == item.title,
                }"
                >{{ item.title }}</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list-group>
      <v-divider />
      <v-list-group :value="false" role="list">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Lenker</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile
          v-for="item in externalLinks"
          :key="item.title"
          :href="item.url"
        >
          <v-list-tile-content class="pl-2">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-divider />

      <v-divider />
      <p style="padding: 15px; font-size: 12px;">
        NVEs kartdata distribueres i henhold til
        <a href="https://data.norge.no/nlod/no"
          >Norsk lisens for offentlige data (NLOD).</a
        >
      </p>
    </v-navigation-drawer>
    <v-toolbar v-else flat color="primary white--text">
      <img
        alt="NVE logo"
        height="40px"
        style="margin-top: 0px;"
        :src="getImgUrl(logoImagePath)"
      /><v-toolbar-title class="headline ml-4">{{ appTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <div>
        <profiles-list
          :show-download-action="true"
          :use-in-dialog="false"
          :selected-category="selectedProfileCategory"
          :open-map-on-click="true"
        />
      </div>
    </v-content>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TheCataloguePage",
  components: {
    ProfilesList: () => import("@/components/ProfilesList"),
  },
  computed: {
    ...mapState([
      "appTitle",
      "profileCategories",
      "externalLinks",
      "logoImagePath",
      "isConnectedToIntranet",
    ]),
  },
  methods: {
    getImgUrl(svgName) {
      let images = require.context("../../assets/", false, /\.(svg|png)$/);

      return images("./" + svgName);
    },
  },
  data() {
    return {
      drawer: true,
      selectedProfileCategory: "Alle",
      testDialogActive: false,
    };
  },
};
</script>

<style>
.active-category {
  font-weight: bolder;
}
</style>
